import React from "react";
import { Box } from "@mui/material";
import { BasketsTabBasketHeader } from "./BasketsTabBasketHeader";
import { BasketPlot } from "../../../../../basketPlot/BasketPlot";
import { BasketMaterial } from "components/basketPlot/types";

interface BasketsTabBasketProps {
  basketNumber: number;
  totalMass: number;
  fullness: number;
  materials: BasketMaterial[];
}

export const BasketsTabBasket: React.FC<BasketsTabBasketProps> = ({
  basketNumber,
  totalMass,
  fullness,
  materials,
}) => {
  return (
    <Box sx={{ flex: 1, maxWidth: 260 }}>
      <BasketsTabBasketHeader
        basketNumber={basketNumber}
        totalMass={totalMass}
        fullness={fullness}
      />
      <BasketPlot
        materials={materials}
        totalMass={totalMass}
        fullness={fullness}
      />
    </Box>
  );
};
